import React from 'react';
import { FooterTW } from './FooterTW';

export interface AppLayoutProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  hideFooter?: boolean;
  stickyHeader?: React.ReactNode;
  /** @deprecated No longer used - TopNavigation was removed */
  hideNavigation?: boolean;
  /** @deprecated No longer used - TopNavigation was removed */
  fullscreenHero?: boolean;
}

/**
 * AppLayout - Einfaches Layout für öffentliche Seiten
 *
 * Wird für nicht-eingeloggte Benutzer verwendet.
 * Navigation erfolgt über die Floating Toolbox in App.tsx.
 */
export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  className = '',
  style,
  hideFooter = false,
  stickyHeader,
  // Deprecated props - accepted but ignored
  hideNavigation: _hideNavigation,
  fullscreenHero: _fullscreenHero,
}) => {
  return (
    <div className={`min-h-screen ${className} flex flex-col bg-gray-950`} style={style}>
      {/* Sticky Header - rendered BEFORE main content */}
      {stickyHeader}

      {/* Main Content */}
      <main className="transition-all duration-300 flex-grow">
        {children}
      </main>

      {/* Footer - conditionally hidden */}
      {!hideFooter && <FooterTW />}
    </div>
  );
};